import { render } from "./PackageList.vue?vue&type=template&id=35e05680&scoped=true"
import script from "./PackageList.vue?vue&type=script&scoped=true&lang=js"
export * from "./PackageList.vue?vue&type=script&scoped=true&lang=js"

import "./PackageList.vue?vue&type=style&index=0&id=35e05680&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e05680"]])

export default __exports__